import type { Observable as ObservableType } from 'rxjs/Observable';
import type { IssueId } from '@atlassian/jira-software-board-common/src/index.tsx';
import type { CardCoversRestApiResponse } from '@atlassian/jira-software-board-uif-types/src/index.tsx';
import { getCardCovers } from '../../rest/card-covers/index.tsx';

// Get card covers for board cards using the REST API. Currently only used for CMP.
export const fetchCardCoversService = (
	issueIds: IssueId[],
): ObservableType<CardCoversRestApiResponse> => getCardCovers(issueIds);
